import { createContext, PropsWithChildren, useContext } from "react";
import { FormApi } from "../shared/types";

const FormContext = createContext<FormApi>(null!);

export function useFormContext<TFormData = any>(): FormApi<TFormData> {
    return useContext(FormContext);
}

interface FormProviderProps<TFormData> extends PropsWithChildren {
    form: FormApi<TFormData>
}

export function FormProvider<TFormData = any>({
    form,
    children
}: FormProviderProps<TFormData>) {
    return <FormContext.Provider value={form}>
        {children}
    </FormContext.Provider>
}